import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import PanelControl from './admin/PanelControl';
import GestionTrabajadores from './admin/GestionTrabajadores';
import EditarFichajes from './admin/EditarFichajes';
import Informes from './admin/Informes';
import Festivos from './admin/Festivos';

const TABS = [
  { id: 'panel',        label: '🏠 Panel',        labelMobile: 'Panel' },
  { id: 'trabajadores', label: '👥 Trabajadores',  labelMobile: 'Equipo' },
  { id: 'fichajes',     label: '📋 Fichajes',      labelMobile: 'Fichajes' },
  { id: 'informes',     label: '📊 Informes',      labelMobile: 'Informes' },
  { id: 'festivos',     label: '🎉 Festivos',      labelMobile: 'Festivos' },
];

export default function AdminView() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState('panel');
  const [fichajesWorker, setFichajesWorker] = useState(null);

  const handleVerFichajes = (trabajador) => {
    setFichajesWorker(trabajador);
    setTab('fichajes');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-mgh-blue-900 text-white shadow-lg z-10">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between py-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-mgh-yellow-400 rounded-xl flex items-center justify-center">
                <span className="text-base font-black text-mgh-blue-900">MGH</span>
              </div>
              <div>
                <div className="font-bold leading-tight">MGH Electricidad</div>
                <div className="text-blue-200 text-xs">Control de Jornada Laboral</div>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="hidden sm:block text-right">
                <div className="text-sm font-medium">{user.nombre} {user.apellidos}</div>
                <div className="text-blue-200 text-xs">Administrador</div>
              </div>
              <button
                onClick={logout}
                className="text-sm text-blue-200 hover:text-white px-3 py-1.5 rounded-lg hover:bg-white/10 transition-colors"
              >
                Salir
              </button>
            </div>
          </div>

          {/* Tabs */}
          <nav className="flex overflow-x-auto hide-scrollbar">
            {TABS.map((t) => (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                className={`flex-shrink-0 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap
                  ${tab === t.id
                    ? 'border-mgh-yellow-400 text-white'
                    : 'border-transparent text-blue-200 hover:text-white hover:border-blue-300'
                  }`}
              >
                <span className="hidden sm:inline">{t.label}</span>
                <span className="sm:hidden">{t.labelMobile}</span>
              </button>
            ))}
          </nav>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 max-w-7xl mx-auto w-full px-4 py-6">
        {tab === 'panel' && <PanelControl onVerFichajes={handleVerFichajes} />}
        {tab === 'trabajadores' && <GestionTrabajadores />}
        {tab === 'fichajes' && (
          <EditarFichajes
            trabajadorInicial={fichajesWorker}
            key={fichajesWorker?.id}
          />
        )}
        {tab === 'informes' && <Informes />}
        {tab === 'festivos' && <Festivos />}
      </main>

      <footer className="text-center text-xs text-gray-400 py-3 border-t border-gray-200">
        MGH Electricidad · Arganda del Rey, Madrid · RD-ley 8/2019
      </footer>
    </div>
  );
}
